export const AUTO_LOGOUT_SETTINGS_KEY = "fz:security:autoLogout";
export const AUTO_LOGOUT_DEFAULT_MINUTES = 60;

export const AUTO_LOGOUT_OPTIONS = [
  { value: 5, label: "5 min" },
  { value: 10, label: "10 min" },
  { value: 15, label: "15 min" },
  { value: 30, label: "30 min" },
  { value: 60, label: "60 min" },
  { value: 120, label: "2 horas" },
  { value: 180, label: "3 horas" },
  { value: 240, label: "4 horas" },
];

const OPTION_VALUES = new Set(AUTO_LOGOUT_OPTIONS.map(item => Number(item.value)));

export function normalizeAutoLogoutSettings(input = null) {
  const rawMinutes = Number(input?.timeoutMinutes ?? input?.minutes ?? input?.value ?? AUTO_LOGOUT_DEFAULT_MINUTES);
  const timeoutMinutes = OPTION_VALUES.has(rawMinutes) ? rawMinutes : AUTO_LOGOUT_DEFAULT_MINUTES;
  return {
    id: AUTO_LOGOUT_SETTINGS_KEY,
    timeoutMinutes,
    updatedAt: input?.updatedAt || null,
    updatedBy: input?.updatedBy || "",
  };
}

export function describeAutoLogoutTimeout(minutes) {
  const option = AUTO_LOGOUT_OPTIONS.find(item => Number(item.value) === Number(minutes));
  return option?.label || `${minutes || AUTO_LOGOUT_DEFAULT_MINUTES} min`;
}

export function readCachedAutoLogoutSettings() {
  try {
    const parsed = JSON.parse(localStorage.getItem(AUTO_LOGOUT_SETTINGS_KEY) || "null");
    return normalizeAutoLogoutSettings(parsed);
  } catch (_) {
    return normalizeAutoLogoutSettings(null);
  }
}

export function cacheAutoLogoutSettings(settings) {
  const normalized = normalizeAutoLogoutSettings(settings);
  try {
    localStorage.setItem(AUTO_LOGOUT_SETTINGS_KEY, JSON.stringify(normalized));
    window.dispatchEvent(new CustomEvent("fz:autoLogoutSettingsChanged", { detail: normalized }));
  } catch (_) {}
  return normalized;
}

export async function pullAutoLogoutSettings({ pullGlobal, userName = "system" } = {}) {
  let normalized = readCachedAutoLogoutSettings();
  if (typeof pullGlobal === "function") {
    try {
      const srv = await pullGlobal(AUTO_LOGOUT_SETTINGS_KEY, userName);
      if (srv?.data != null) normalized = normalizeAutoLogoutSettings(srv.data);
    } catch (_) {}
  }
  return cacheAutoLogoutSettings(normalized);
}

export async function saveAutoLogoutSettings({ pushGlobal, settings, userName = "admin" } = {}) {
  const normalized = normalizeAutoLogoutSettings({
    ...settings,
    updatedAt: new Date().toISOString(),
    updatedBy: userName,
  });
  if (typeof pushGlobal === "function") {
    await pushGlobal(AUTO_LOGOUT_SETTINGS_KEY, normalized, userName);
  }
  return cacheAutoLogoutSettings(normalized);
}
